<template>
	<el-tag :type="tagType">{{Value}}</el-tag>
</template>
<script>
	/**
	* Tag标签组件
	* @author wxq
	* @time 2017.9.19
	* @param tagCategory  【description: 类别 , 必要 ,如 qt,bd_status,sb_yingyong,ck_yinyong,td_yinyong】
	* @param tagStatus  【description: 状态 , 必要 ,如 单据状态，某某引用的状态】
	*/
	export default {
		name: 'LyTag',
		props: {
			tagCategory: {
				type: String,
				default: ''
			},
			tagStatus: [Number, String]
		},
		data () {
			return {
				Value: '',
				tagType: ''
			}
		},
		mounted () {
			this.statusDispose()
		},
		watch: {
			tagStatus () {
				this.statusDispose()
			},
			tagCategory () {
				this.statusDispose()
			}
		},
		methods: {
			/**
			 * 状态处理
			 */
			statusDispose () {
				// bd_status 单据审核  2是已审核 11是已作废
				if (this.tagCategory === 'bd_status') {
					if (this.tagStatus === 2) {
						this.tagType = 'success' // primary/gray/success/warning/danger
						this.Value = '已审核'
					} else if (this.tagStatus === 11) {
						this.tagType = 'warning' 
						this.Value = '已作废'
					} else {
						this.tagType = 'primary' 
						this.Value = '待审核'
					}
				}
				// sb_yinyong 单据理赔引用
				if (this.tagCategory === 'sb_yinyong') {
					if (this.tagStatus === 1) {
						this.tagType = 'success' // primary/gray/success/warning/danger
						this.Value = '已被理赔引用'
					} else {
						this.tagType = 'warning' 
						this.Value = '未被理赔引用'
					}
				}
				// ck_yinyong 单据出库引用
				if (this.tagCategory === 'ck_yinyong') {
					if (this.tagStatus === 1) {
						this.tagType = 'success' // primary/gray/success/warning/danger
						this.Value = '已被出库引用'
					} else {
						this.tagType = 'warning' 
						this.Value = '未被出库引用'
					}
				}
				// td_yinyong 单据退单引用
				if (this.tagCategory === 'td_yinyong') {
					if (this.tagStatus === 1) {
						this.tagType = 'success' // primary/gray/success/warning/danger
						this.Value = '已被退单引用'
					} else {
						this.tagType = 'warning' 
						this.Value = '未被退单引用'
					}
				}
				// yinyong 单据引用
				if (this.tagCategory === 'yinyong') {
					if (this.tagStatus === 1) {
						this.tagType = 'success' // primary/gray/success/warning/danger
						this.Value = '已引用'
					} else {
						this.tagType = 'danger' 
						this.Value = '未被引用'
					}
				}
				// xs_status 销售单状态
				if (this.tagCategory === 'xs_status') {
					if (this.tagStatus === 1) {
						this.tagType = 'success' // primary/gray/success/warning/danger
						this.Value = '已生成'
					} else {
						this.tagType = 'danger' 
						this.Value = '未生成'
					}
				}
				// lp_mode 理赔方式
				if (this.tagCategory === 'lp_mode') {
					if (this.tagStatus === 1) {
						this.tagType = 'warning' // primary/gray/success/warning/danger
						this.Value = '赔胎'
					} else {
						this.tagType = 'danger' 
						this.Value = '赔钱'
					}
				}
				// 银行回款确认单详情
				if (this.tagCategory === 'payconfirm') {
					this.tagType = 'success'
					if (String(this.tagStatus) === '1') {
						this.tagType = 'primary'
						this.Value = '待处理'
					} else if (String(this.tagStatus) === '21') {
						this.Value = '已对账'
					} else if (String(this.tagStatus) === '22') {
						this.Value = '已登记'
					} else if (String(this.tagStatus) === '23') {
						this.Value = '已备注'
					}
				}
				// 银行回款登记详情
				if (this.tagCategory === 'paycheckin') {
					if (String(this.tagStatus) === '1') {
						this.tagType = 'warning'
						this.Value = '待对账'
					} else if (String(this.tagStatus) === '2') {
						this.tagType = 'success'
						this.Value = '已对账'
					} else if (String(this.tagStatus) === '3') {
						this.tagType = 'danger'
						this.Value = '已作废'
					}
				}
				// 收款账户详情（原银行账户详情）
				if (this.tagCategory === 'bankaccount') {
					if (String(this.tagStatus) === '1') {
						this.tagType = 'warning'
						this.Value = '现金收款'
					} else if (String(this.tagStatus) === '0') {
						this.tagType = 'success'
						this.Value = '非现金收款'
					}
				}
			}
		}
	}
</script>